(() => {
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100);

  function closeMegaMenus(except) {
    qa('[data-yeti-nav-item].is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      const trigger = q('[data-yeti-nav-trigger]', item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  qa('[data-yeti-nav-item]').forEach((item) => {
    const trigger = q('[data-yeti-nav-trigger]', item);
    if (!trigger) return;
    let clickPinned = false;
    const open = () => {
      closeMegaMenus(item);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => { clickPinned = false; close(); });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
    trigger.addEventListener('click', () => {
      if (clickPinned && item.classList.contains('is-open')) {
        clickPinned = false;
        close();
      } else {
        clickPinned = true;
        open();
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = q('[data-yeti-nav-item].is-open');
    if (open) {
      const trigger = q('[data-yeti-nav-trigger]', open);
      closeMegaMenus();
      trigger?.focus();
    }
    q('[data-yeti-mobile-dialog][open]')?.close();
    closeCart();
  });

  const mobileDialog = q('[data-yeti-mobile-dialog]');
  q('[data-yeti-mobile-open]')?.addEventListener('click', () => mobileDialog?.showModal());
  q('[data-yeti-mobile-close]')?.addEventListener('click', () => mobileDialog?.close());
  mobileDialog?.addEventListener('click', (event) => {
    if (event.target === mobileDialog) mobileDialog.close();
  });

  qa('[data-yeti-tabs]').forEach((tabs) => {
    const buttons = qa('[role="tab"]', tabs);
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((candidate) => {
        const selected = candidate === button;
        candidate.setAttribute('aria-selected', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(candidate.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }));
  });

  qa('[data-yeti-video-toggle]').forEach((button) => {
    const video = q('video', button.closest('[data-yeti-video]'));
    if (!video) return;
    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        button.textContent = 'Pause video';
      } else {
        video.pause();
        button.textContent = 'Play video';
      }
    });
  });

  qa('[data-yeti-gallery]').forEach((gallery) => {
    const main = q('[data-yeti-main-image]', gallery);
    qa('[data-yeti-thumb]', gallery).forEach((thumb) => thumb.addEventListener('click', () => {
      if (main) {
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
      }
      qa('[data-yeti-thumb]', gallery).forEach((candidate) => candidate.setAttribute('aria-current', String(candidate === thumb)));
    }));
  });

  qa('[data-yeti-quantity]').forEach((control) => {
    const input = q('input[type="number"]', control);
    if (!input) return;
    q('[data-yeti-minus]', control)?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min) || 1, (Number(input.value) || 1) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    q('[data-yeti-plus]', control)?.addEventListener('click', () => {
      const maximum = Number(input.max) || 99;
      input.value = String(Math.min(maximum, (Number(input.value) || 1) + 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  qa('[data-yeti-product]').forEach((root) => {
    const dataNode = q('[data-yeti-variants]', root);
    const form = q('form[action*="/cart/add"]', root);
    if (!dataNode || !form) return;
    const variants = JSON.parse(dataNode.textContent || '[]');
    const optionNames = JSON.parse(dataNode.dataset.optionNames || '[]');
    const idInput = q('input[name="id"]', form);
    const addButton = q('[data-yeti-add]', form);
    const priceNode = q('[data-yeti-current-price]', root);
    const compareNode = q('[data-yeti-compare-price]', root);
    const skuNode = q('[data-yeti-sku]', root);
    const stockNode = q('[data-yeti-stock]', root);
    const imageNode = q('[data-yeti-main-image]', root);
    const currency = dataNode.dataset.currency || 'USD';

    const update = () => {
      const selected = optionNames.map((name, index) => q(`input[name="option-${index}"]:checked`, root)?.value || '');
      // Shopify exposes the implicit singleton option as ["Title"] even
      // though the Liquid picker is intentionally omitted for a default-only
      // product. In that case there is no radio value to compare and the old
      // matcher disabled an otherwise available product as "Unavailable".
      const variant = optionNames.length === 1 && variants.length === 1 && !q('input[data-yeti-option]', root)
        ? variants[0]
        : variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
      if (!variant) {
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNode) priceNode.textContent = money(variant.price, currency);
      if (compareNode) {
        compareNode.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, currency) : '';
        compareNode.hidden = !(variant.compare_at_price > variant.price);
      }
      if (skuNode) skuNode.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
      if (stockNode) {
        stockNode.textContent = variant.available ? 'In stock' : 'Sold out';
        stockNode.classList.toggle('is-sold', !variant.available);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (imageNode && variant.featured_image?.src) {
        imageNode.src = variant.featured_image.src;
        imageNode.alt = variant.featured_image.alt || imageNode.alt;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    qa('input[data-yeti-option]', root).forEach((input) => input.addEventListener('change', update));
    update();
  });

  const drawer = q('[data-yeti-cart-drawer]');
  const drawerBody = q('[data-yeti-cart-body]', drawer || document);
  const drawerSubtotal = q('[data-yeti-cart-subtotal]', drawer || document);
  const drawerCount = q('[data-yeti-cart-drawer-count]', drawer || document);
  const countBadges = qa('[data-yeti-cart-count]');
  let lastFocus = null;

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    q('[data-yeti-cart-close]', drawer)?.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lastFocus?.focus?.();
  }
  window.closeYetiCart = closeCart;

  async function refreshCart(open = false) {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Cart ${response.status}`);
    const cart = await response.json();
    countBadges.forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price, cart.currency || 'USD');
    if (drawerBody) {
      if (!cart.items.length) {
        drawerBody.innerHTML = '<div class="yeti-cart-empty"><p>Your cart is empty.</p><a class="yeti-btn yeti-btn--outline" href="/collections/shop-all">Continue shopping</a></div>';
      } else {
        drawerBody.innerHTML = cart.items.map((item) => `<article class="yeti-drawer-item">
          <a href="${item.url}"><img src="${item.image || ''}" alt="${(item.product_title || '').replaceAll('"', '&quot;')}" width="82" height="82"></a>
          <div><h3><a href="${item.url}">${item.product_title}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="yeti-cart-meta">${item.variant_title}</div>` : ''}<div class="yeti-price">${money(item.final_line_price, cart.currency || 'USD')}</div><div>Qty: ${item.quantity}</div></div>
        </article>`).join('');
      }
    }
    if (open) openCart();
    return cart;
  }

  q('[data-yeti-cart-open]')?.addEventListener('click', () => refreshCart(true).catch(() => openCart()));
  q('[data-yeti-cart-close]')?.addEventListener('click', closeCart);
  q('[data-yeti-cart-overlay]')?.addEventListener('click', closeCart);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    const button = q('[data-yeti-add]', form);
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error(`Add ${response.status}`);
      await refreshCart(true);
    } catch (error) {
      const status = q('[data-yeti-form-status]', form);
      if (status) status.textContent = 'This item could not be added. Please try again.';
    } finally {
      if (button) { button.disabled = false; button.textContent = button.dataset.label || 'Add to cart'; }
    }
  });

  refreshCart(false).catch(() => {});
})();
